export interface ShouldSelectUserFromRouteInput {
  /** The `user_id` segment of the current route, if the route has one. */
  routeUserId: string | undefined;
  /** `ctx.selectedUser` as the manager machine currently holds it. */
  selectedUserId: string | undefined;
}

/**
 * Decide whether the route sync should send `manager.selectUser`.
 *
 * The rule is "advance only": the sync moves the selection to a user the URL
 * names, and never clears it because the URL names nobody. A route without a
 * `user_id` segment is not evidence that no user is selected — My Account
 * (PSTUDIO-4095) shows the logged-in user's own details on
 * `/organization/:org_id/my-account`, which carries no `user_id`, while
 * `ctx.selectedUser` is read by `autoSaveUserDetails`,
 * `toggleAllOrgCollapseState`, `manager.userDetails.updateUserSettings` and
 * `updateProjectMetabaseAccess` in the manager machine, and by primary-nav's
 * `isCurrentUser` — each of them returning early or reading nothing when the
 * selection is empty, with no error to show for it.
 *
 * Clearing is not lost, it is owned elsewhere: `UserDetailsPage` sends
 * `manager.clearSelectedUser` when it unmounts, which is what actually ends a
 * user-details visit. `applet_id` is already treated this way in the same sync
 * function.
 */
export const shouldSelectUserFromRoute = ({
  routeUserId,
  selectedUserId,
}: ShouldSelectUserFromRouteInput): boolean =>
  Boolean(routeUserId) && routeUserId !== selectedUserId;
